<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import 'moment/locale/es';
import { mujerMethods, mujerComputed } from "@/state/helpers";

Vue.use(VueAxios, axios)
Vue.use(Vuetify)
/**
 * tablaSucursales component
 */
export default {
  props: {
    tableSucursales: {
      type: Array,
      default: function () {
        return [];
      },
    },
    getTable:{
      type: Function
    }
  },
  data() {
    return {
      showModal: false,
      dialog: false,
      dialogDelete: false,
      empty:''
      
    };
  },

 computed: {
		...mujerComputed,
		formTitle () {
			return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
		},
	},


 mounted() {
    
    console.log(this.tableSucursales);

 }, 

 

 filters: {
   moment: function (date) {
     return moment(date).format('LL');
   }
 },

 methods: {


  handleDelete(id_usuario){
    console.log(id_usuario);
    this.$swal({
      title: '¿Estas seguro de borrar?',
      text: "",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, borrar',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {

        axios.put("https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/usuarios",{"id_usuario":id_usuario,"estatus": "0"})
        .then((res) => {
          const {response=""} = res.data;
          if (response === true) {
            this.$swal(
              'Eliminado!',
              'El usuario ha sido borrado con exito.',
              'success'
            )
            this.tableWoman= [];
            this.getTable();
            
          }else{
            this.$swal(
              'Alerta!',
              'No se pudieron realizar los cambios',
              'warning'
              );
          }
        })
        .catch(error => {
          this.errorMessage = error.message;
          console.log(error);
          this.$swal(
              'Error!',
              'Ocurrio un error',
              'danger'
              );
        });
      }
    })
  },

   test(data){
    console.log(data);
    this.fecthMujer(data);
    this.$router.push('/ActualizaMTarjeta');
   },

    moment: function (date) {
      return moment(date);
    },
    date: function (date) {
      return moment(date).format('LL');
    },
    ...mujerMethods,
  myFunction() {
		// Declare variables
		var input, filter, table, tr, td, i, txtValue;
		input = document.getElementById("myInput");
		filter = input.value.toUpperCase();
		table = document.getElementById("myTable");
		tr = table.getElementsByTagName("tr");

		// Loop through all table rows, and hide those who don't match the search query
		for (i = 0; i < tr.length; i++) {
			td = tr[i].getElementsByTagName("td")[0];
			if (td) {
				txtValue = td.textContent || td.innerText;
				if (txtValue.toUpperCase().indexOf(filter) > -1) {
					tr[i].style.display = "";
				} else {
					tr[i].style.display = "none";
				}
			}
		}
	},
  sortTable(n) {
  var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
  table = document.getElementById("myTable");
  switching = true;
  // Set the sorting direction to ascending:
  dir = "asc";
  /* Make a loop that will continue until
  no switching has been done: */
  while (switching) {
    // Start by saying: no switching is done:
    switching = false;
    rows = table.rows;
    /* Loop through all table rows (except the
    first, which contains table headers): */
    for (i = 1; i < (rows.length - 1); i++) {
      // Start by saying there should be no switching:
      shouldSwitch = false;
      /* Get the two elements you want to compare,
      one from current row and one from the next: */
      x = rows[i].getElementsByTagName("TD")[n];
      y = rows[i + 1].getElementsByTagName("TD")[n];
      /* Check if the two rows should switch place,
      based on the direction, asc or desc: */
      if (dir == "asc") {
        if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
          // If so, mark as a switch and break the loop:
          shouldSwitch = true;
          break;
        }
      } else if (dir == "desc") {
        if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
          // If so, mark as a switch and break the loop:
          shouldSwitch = true;
          break;
        }
      }
    }
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark that a switch has been done: */
      rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
      switching = true;
      // Each time a switch is done, increase this count by 1:
      switchcount ++;
    } else {
      /* If no switching has been done AND the direction is "asc",
      set the direction to "desc" and run the while loop again. */
      if (switchcount == 0 && dir == "asc") {
        dir = "desc";
        switching = true;
      }
    }
  }
}

}
}
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table table-centered table-nowrap align-middle" id="myTable">
      <thead class="table-light">
        <tr>
          <th class="align-middle"> <button class="botontabla" v-on:click="sortTable(0)">ID</button> </th>
          <th class="align-middle"> <button class="botontabla" v-on:click="sortTable(1)">Nombre</button> </th>
          <th class="align-middle"> <button class="botontabla" v-on:click="sortTable(2)">Telefono</button> </th>
          <th class="align-middle"> <button class="botontabla" v-on:click="sortTable(3)">Fecha de creación</button> </th>
          <th class="align-middle"> <button class="botontabla" v-on:click="sortTable(4)">Estado</button> </th>
          <th class="align-middle" > <center> <i class='bx bx-dots-vertical-rounded'></i></center></th>
        </tr>
      </thead>
      <tbody >
      
        <tr v-for="data in tableSucursales" :key="data.id_sucursal">
          <td>
            <a href="javascript: void(0);" class="text-body fw-bold filter">{{
              data.id_sucursal
            }}</a>
          </td>
          <td>{{ data.nombre }}</td>
          <td>{{ data.telefono }}</td>
          <td>{{ data.fecha_creacion | moment}}</td>
          <td>
            <span
              class="badge badge-pill bg-success font-size-11"
              :class="{
                'bg-warning': `${data.estatus}` === '0',
                'bg-success': `${data.estatus}` === '1',
              }"
              >{{ data.estatus === 1 ? 'Activo' : 'Desactivo' }}</span
            >
          </td>
          <td>
						<a href="#" v-on:click="test(data)">
							<v-btn flat icon color="#09A5C7"
						>
							<i class='bx bxs-pencil'></i>
						</v-btn>
						</a>
						<v-btn flat icon color="#E73484"
							@click="handleDelete(data.id_usuario)"
						>
							<i class='bx bx-trash'></i>
						</v-btn>
										<v-dialog
											v-model="dialog"
											max-width="290"
										>
								<v-card>
									<v-card-title class="text-h5">
										Use Google's location service?
									</v-card-title>

									<v-card-text>
										Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.
									</v-card-text>

									<v-card-actions>
										<v-spacer></v-spacer>

										<v-btn
											color="green darken-1"
											text
											@click="dialog = false"
										>
											Disagree
										</v-btn>

										<v-btn
											color="green darken-1"
											text
											@click="dialog = false"
										>
											Agree
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
          </td>
        </tr>
      </tbody>
    </table>
    <div><h4>{{empty}}</h4></div>
  </div>
  <!-- end table -->
</template>

<style>

.botontabla{
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    border:0px;
        width:10px;
        height:10px;
    
}

</style>
